import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/** Maps the deepest active selection into Current List's edited filters. */
export const setEditedFilterOnSelection = store.effects.create(
  <TTypeParams extends Plugin.TypeParams>(
    _feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    plugin.actions.setSelection.success.observe().pipe(
      rxjsUtils.latestFrom(action => ({
        action: rxjs.of(action),
        deepestSelection: plugin.selectors.deepestSelection.asObservable,
        filters:
          plugin.collection.plugins.currentListPlugin.editedParams.selectors
            .filters.asObservable,
      })),
      rxjs.map(({ action, deepestSelection, filters }) =>
        plugin.collection.plugins.currentListPlugin.editedParams.actions.setFilters
          .from(action)
          .create(plugin.currentListFilter.set(filters, deepestSelection)),
      ),
    ),
)
